// src/firebase.js
// ─────────────────────────────────────────────────────────────────────
// Replace the placeholder values below with your actual Firebase project
// config. You get these from:
//   Firebase Console → Your Project → Project Settings → Your Apps → SDK setup
// ─────────────────────────────────────────────────────────────────────

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey:            "AIzaSyAHmCy8L1_BObVo_MNXrjFYlPz9dwt0gRg",
  authDomain:        "nudge-f3a8f.firebaseapp.com",
  projectId:         "nudge-f3a8f",
  storageBucket:     "nudge-f3a8f.firebasestorage.app",
  messagingSenderId: "990799916772",
  appId:             "1:990799916772:web:b1fd3c7dcf74fa3fe546f1",
};

const app        = initializeApp(firebaseConfig);
export const db  = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
